import { Component, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { Subject, forkJoin, of } from 'rxjs';
import { takeUntil, switchMap, catchError } from 'rxjs/operators';
import { NgbdSortableHeader, SortEvent } from 'src/app/directives/sort.directive';
import { IGetCodes, IGetCodesName, IStudyUnitPracticeTest } from 'src/app/interfaces/codes';
import { IMockExam, ICoursePlanMockExam } from 'src/app/Models/ExamAgencies';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { ExamManagementService } from 'src/app/Services/exam-management/exam-management.service';
import { SessionService } from 'src/app/Services/session.service';
import { AddEditMockExamModalComponent } from '../add-edit-mock-exam-modal/add-edit-mock-exam-modal.component';
import { compare } from '../exam-agencies/exam-agencies.component';
import { AddStudymaterialPracticeTestComponent } from '../add-studymaterial-practice-test/add-studymaterial-practice-test.component';
import { StudyunitPracticeTestService } from 'src/app/Services/studyunit-practice-test.service';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { IPracticeQuestions } from 'src/app/Models/QuestionMaster';
import { NotificationAddEditComponent } from '../../notification-management/notification-add-edit/notification-add-edit.component';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';


@Component({
  selector: 'app-studymaterial-pratcice-test',
  templateUrl: './studymaterial-pratcice-test.component.html',
  styleUrls: ['./studymaterial-pratcice-test.component.css'],
})
export class StudymaterialPratciceTestComponent implements OnInit {
  courseId: string = '';
  ExamAgencyName: string = '';
  CourseName: string = '';
  ExamYear: string = '';
  currentRoute: string = '';
  private destroy$ = new Subject<void>(); // Used for unsubscribing
  courses: IGetCodes[];
  CourseAppliableCourseType: ICoursePlanMockExam[];
  public sortColumn: keyof any;
  public sortDirection: 'asc' | 'desc' | '' = '';
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  subjectId: string = "";
  subjectControl = new FormControl('');
  practiceTest: IStudyUnitPracticeTest[] = [];
  unpracticeTest: IStudyUnitPracticeTest[] = [];
  subjects: IGetCodes[] = [];
  selectedPracticeTestId: number | null = null;
  private subjectManuallySelected = false;


  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    public service: ContentManagementService,
    public toastr: ToastrService,
    private ExamService: ExamManagementService,
    public session: SessionService,
    private practiceTestService:StudyunitPracticeTestService,
    private modalServiceLocal: ModalService,
  ) {}

  ngOnInit(): void {
    this.subjectControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.onSubjectChange((value || '').toString());
      });

    this.route.queryParams
      .pipe(
        takeUntil(this.destroy$),
        switchMap((queryParams) => {
          const incomingCourseId = queryParams['c_id'] || '';
          const isCourseChanged = incomingCourseId !== this.courseId;

          this.courseId = incomingCourseId;
          this.ExamAgencyName = queryParams['eA_Name'];
          this.CourseName = queryParams['c_Name'];
          this.ExamYear = queryParams['eY_Name'];

          if (isCourseChanged) {
            this.subjectManuallySelected = false;
            this.subjectId = '';
            this.subjectControl.setValue('', { emitEvent: false });
          }

          const incomingSubId = (queryParams['sub_id'] || '').toString().trim();
          if (incomingSubId && (!this.subjectManuallySelected || isCourseChanged)) {
            this.subjectId = incomingSubId;
            this.subjectControl.setValue(this.subjectId, { emitEvent: false });
          }
          // Get Subjects
          this.getSubjects();

          return forkJoin({
            courseCodes: this.service
              .GetCode({ Tablename: 'COURSE_PLAN_TYPE' })
              .pipe(
                catchError((error) => {
                  console.error('Error fetching course codes:', error);
                  return of([]);
                })
              ),
            coursePlans: this.service
              .getCoursePlan$(
                this.session.getUser(),
                +this.courseId,
                '',
                'ASSIGNMOCKEXAM',
                '',
                ''
              )
              .pipe(
                catchError((error) => {
                  console.error('Error fetching course plans:', error);
                  return of(null);
                })
              ),
            applicableCoursePlans:
              this.ExamService.getMockExamApplicableCoursePlan({
                ScreenName: 'ASSIGNMOCKEXAMTOCOURSEPLAN',
                CourseTestID: null,
                CourseID: +this.courseId,
                CoursePlanID: null,
                SelectedInd: null,
              }).pipe(
                catchError((error) => {
                  console.error(
                    'Error fetching applicable course plans:',
                    error
                  );
                  return of(null);
                })
              ),
          });
        })
      )
      .subscribe(({ courseCodes, coursePlans, applicableCoursePlans }) => {
        this.getStudyUnitPracticeTest();
        this.courses = courseCodes;
        this.CourseAppliableCourseType = applicableCoursePlans;
      });



  }

  getSubjects(){
    this.practiceTestService.getSubject(this.courseId).subscribe(
      (res:any)=>{
        this.subjects = res;

        const currentValue = (this.subjectControl.value || '').toString().trim();
        const normalizedSubjectId = (this.subjectId || '').toString().trim();
        const selectedCode = currentValue || normalizedSubjectId;
        const selectedExists = this.subjects.some((s: IGetCodes) => (s.Code || '').toString().trim() === selectedCode);

        // Re-apply selected value after options refresh to keep select UI and control value in sync.
        this.subjectControl.setValue(selectedExists ? selectedCode : '', { emitEvent: false });
        this.subjectId = this.subjectControl.value;

      },
      (error)=>{
        console.log(error);

      }
    )
  }



  onSubjectChange(nextValue: string) {
    this.subjectManuallySelected = true;
    this.subjectId = (nextValue || '').toString().trim();

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { sub_id: this.subjectId || null },
      queryParamsHandling: 'merge',
    });
  }

  compareStringValues(a: string, b: string): boolean {
    return (a || '').toString().trim() === (b || '').toString().trim();
  }

  getStudyUnitPracticeTest() {
    this.selectedPracticeTestId =null // To un select the selected Row
    if (!this.subjectId) {
      this.practiceTest = [];
      this.unpracticeTest = [];
      return;
    }
    const payload = {
      SubjectID: +this.subjectId,
      ScreenName: "ASSIGNStudyUnitPracticeTestTOCOURSEPLAN",
      CourseID: +this.courseId,
      CoursePlanID: null,
      CourseTestID: null,
      SelectedInd: null
    };

    this.practiceTestService.getStudyUnitPracticeTestApplicableCoursePlan(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: IStudyUnitPracticeTest[]) => {
          // GROUP by Course_Test_Id
          const grouped = new Map<number, any>();
          res.forEach(item => {
            if (!grouped.has(item.Course_Test_Id)) {
              grouped.set(item.Course_Test_Id, {
                ...item,
                Course_Plan_Type_Codes: item.Deleted_Ind !== 'Y' ? [item.Course_Plan_Type_Code] : []
              });
            } else {
              if (item.Deleted_Ind !== 'Y') {
                grouped.get(item.Course_Test_Id).Course_Plan_Type_Codes.push(item.Course_Plan_Type_Code);
              }
            }
          });
          this.unpracticeTest = Array.from(grouped.values());
          this.practiceTest = [...this.unpracticeTest];

                //GETTING SELECTED TEST BACK
                this.practiceTestService.getSelectedPracticeTestId()
                .pipe(takeUntil(this.destroy$))
                .subscribe((id) => {
                  // Only set if id exists in current list, otherwise clear selection
                  if (this.practiceTest?.some(p => p.Course_Test_Id === id)) {
                    this.selectedPracticeTestId = id;
                  } else {
                    this.selectedPracticeTestId = null;
                  }
                });
        },
        (error) => {
          console.log(error);
        }
      );
  }

  selectPracticeTest(item: any) {

    this.selectedPracticeTestId = item.Course_Test_Id;
    this.practiceTestService.setSelectedPracticeTestId(item.Course_Test_Id);
  }

  checkedCoursePlan(type: string, code: string): boolean {
    return type ===code;
  }



  AddEditPracticeTest(practiceTest?: IStudyUnitPracticeTest) {
    if(!this.subjectId){
      this.toastr.error('Please select a subject first','',{
        timeOut:ConstantVars.ToastErrorTimeout
      })
      return
    }
    const modalRef = this.modalService.open(AddStudymaterialPracticeTestComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modalRef.componentInstance.PracticeTest = practiceTest || undefined;
    modalRef.componentInstance.subjectId = +this.subjectId || undefined;
    modalRef.result.then(
      (result) => {
        console.log('Modal closed with result:', result);
        // Perform actions after modal is closed
        this.CreateNotification(result)
        this.getStudyUnitPracticeTest();

      },
      (reason) => {
        console.log('Modal dismissed:', reason);
      }
    );
  }
    async CreateNotification(materialId:any): Promise<boolean> {
      try {
        // Step 1: Ask for confirmation
        const result = await this.modalServiceLocal.open(
          'Confirmation',
          'Do you want to send notification to all the users about this Practice Test?',
          'Yes',
          'No'
        );

        if (!result) {
          return false; // user cancelled
        }

        // Step 2: Open notification modal
        const modalRef = this.modalService.open(NotificationAddEditComponent, {
          centered: true,
          size: 'xl',
          windowClass: 'custom-modal-width-notification-course',
          backdropClass: 'custom-backdrop-notification'
        });

        // Pass data into modal
        modalRef.componentInstance.screenName = 'PracticeTest';
        modalRef.componentInstance.MaterialId =materialId

        // Step 3: Wait for modal close result
        const notificationResult = await modalRef.result
          .then((res: any) => {res

          })
          .catch(() =>{
            return false

          });


        return !!notificationResult;
      } catch (error) {
        console.error('CreateNotification dismissed or failed:', error);
        return false;
      }
    }

  navigateToPracticeQuestions(test:IStudyUnitPracticeTest){
    const navigationExtras: NavigationExtras = {
      queryParams: {
        c_id: this.courseId,
        eA_Name: this.ExamAgencyName,
        c_Name: this.CourseName,
        eY_Name: this.ExamYear,
        m_Seq: test.Course_Test_Id,
        sub_Id: this.subjectId,
      },
      skipLocationChange: false,
    };
    this.practiceTestService.setSelectedPracticeTestId(test.Course_Test_Id);
    this.router.navigate(
      ['Exam/StudyUnit/PracticeTestQuestion', test.Course_Test_Id],
      navigationExtras
    );
  }

  getPlanNameInitails(courseName: string) {
    if (courseName.split(' ')[1] === 'Plan') {
      return courseName.split(' ')[0];
    } else {
      return courseName;
    }
  }
  public onSort({ column, direction }: SortEvent) {
    const source = this.unpracticeTest || [];

    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // sorting countries
    if (direction === '' || column === '') {
      this.practiceTest = [...source];
      this.sortColumn = '';
      this.sortDirection = '';
    } else {
      this.sortColumn = column;
      this.sortDirection = direction;
      this.practiceTest = [...source].sort((a: any, b: any) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }


  ngOnDestroy(): void {
    this.destroy$.next(); // Emit value to trigger unsubscription
    this.destroy$.complete(); // Ensures Subject is fully closed
      // Get the full URL
  const fullUrl = this.router.url;

  // If the current URL does NOT include 'Exam/StudyMaterial', clear the selection
  if (!fullUrl.includes('Exam/StudyUnit')) {
    this.practiceTestService.setSelectedPracticeTestId(null);
  }
  }

}
